// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__3w3Gr","div":"Header_div___CaqI","logo":"Header_logo__gq41D","app_title":"Header_app_title__2Tusl"};